export const blogTags = [
    "Web Development",
    "Next.js",
    "TypeScript",
    "Three.js",
    "MERN Stack",
    "JavaScript",
    "React.js",
    "Node.js",
    "API Development",
    "Modern Tech",
    "Time Management",
    "Startup Life",
    "Developer Workflow",
    "Code Optimization",
    "Debugging Tips",
    "User Experience (UX)",
    "UI Design",
    "Responsive Design",
    "Prototyping",
    "Open Source",
    "VS Code",
    "GitHub",
    "DevOps",
    "Testing Tools",
    "Learning Resources",
    "Beginner Tips",
    "Coding Challenges",
    "Career Advice"
  ];
  